// When a mutating request (POST/PUT/DELETE) returns a 401, the UI hard-reloads to run
// the OIDC flow, silently discarding the action. We record that here before reloading,
// then surface a warning on the next load (see SessionReauthNotice) so the user knows
// to repeat the action. sessionStorage is used deliberately: it survives the reload and
// the MSAL redirect to Azure AD and back, but is scoped to the tab that lost the action.

const KEY = "cloudportal:reauth-dropped-action";

export function markActionDroppedByReauth() {
  try {
    sessionStorage.setItem(KEY, "true");
  } catch (e) {
    // sessionStorage can be unavailable (e.g. privacy settings); the warning is best-effort.
    console.warn(e, "Failed to record reauth-dropped action");
  }
}

// Read-and-clear: returns true once after a drop, then false on subsequent loads.
export function consumeActionDroppedByReauth(): boolean {
  try {
    const dropped = sessionStorage.getItem(KEY) === "true";
    if (dropped) sessionStorage.removeItem(KEY);
    return dropped;
  } catch (e) {
    return false;
  }
}
